import { ValidationTextMap, validateDate, zeroSelected } from 'components/form/validations';

const validateFilterDate = validateDate;

const zeroPaymentStatusesSelected = zeroSelected('payment status');
const zeroPaymentMethodsSelected = zeroSelected('payment method');
const zeroTicketStatusSelected = zeroSelected('ticket status');
const zeroPlanStatusesSelected = zeroSelected('plan status');
const zeroPlanFrequenciesSelected = zeroSelected('plan frequency');
const zeroPledgeStatusesSelected = zeroSelected('pledge status');
const zeroPledgeTypesSelected = zeroSelected('pledge type');
const zeroPledgeFrequenciesSelected = zeroSelected('pledge frequency');
const zeroCampaignTypesSelected = zeroSelected('campaign type');
const zeroTransactionTypesSelected = zeroSelected('transaction type');
const zeroDonorSearchRatingsSelected = zeroSelected('DonorSearch Rating');
const zeroMailingsStatusSelected = zeroSelected('tracking status');
const zeroCustomFieldsSelected = zeroSelected('custom field');
const zeroQuickBooksTransactionStatusSelected = zeroSelected('sync status');
const zeroContactTypesSelected = zeroSelected('contact type');

export {
    ValidationTextMap,
    validateFilterDate,
    zeroPlanStatusesSelected,
    zeroCampaignTypesSelected,
    zeroTransactionTypesSelected,
    zeroPaymentMethodsSelected,
    zeroPlanFrequenciesSelected,
    zeroPledgeStatusesSelected,
    zeroPledgeFrequenciesSelected,
    zeroPledgeTypesSelected,
    zeroTicketStatusSelected,
    zeroPaymentStatusesSelected,
    zeroDonorSearchRatingsSelected,
    zeroMailingsStatusSelected,
    zeroCustomFieldsSelected,
    zeroQuickBooksTransactionStatusSelected,
    zeroContactTypesSelected,
};
